
import { defineComponent } from 'vue'

export default defineComponent(
  {
    name: 'DefaultButton',
    props: {
      textBtn: {
        type: String,
        default: ''
      },
      backgroundColor: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        defautl: ''
      },
      path: {
        type: String,
        default: ''
      }
    },
    data() {
      return {

      }
    },
    computed: {
      classes() {
        const classes = [
          this.backgroundColor ? `background-color-${this.backgroundColor}` : '',
          this.color ? `color-${this.color}` : ''
        ]
        return classes
      }
    }
  }
)

